import React from 'react'

import Footer from '../../components/footer'
import GenreHeader from '../../components/genre-header'
import Header from '../../components/header'
import pageTitleFromPathname from '../../../common/lib/pagetitle-from-pathname'
import Shelves from '../../components/shelves'
import titles from '../../../common/assets/titles.json'

export default (props) => {
	const {
		pathname
	} = props

	const pageTitle = pageTitleFromPathname(pathname)

	return (
		<React.Fragment>
			<Header />
			<GenreHeader text={pageTitle} />
      <Shelves titles={titles} />
			<Footer />
		</React.Fragment>
	)
}


// WEBPACK FOOTER //
// ./src/mobile/pages/genre/index.js